module.exports = __webpack_public_path__ + "static/SM7-4624ea00cc227d5177e0fd77ac61cc3c.png";